// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paper-canvas_paper-canvas_IICvh {
  top: 1px; /* leave room for the border */
  left: 1px;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  margin: auto;
  position: absolute;
  background-color: #d9e3f2;
}
[data-paint-theme='dark'] .paper-canvas_paper-canvas_IICvh {
  background-color: #222;
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/containers/paper-canvas.css"],"names":[],"mappings":"AAAA;EACE,QAAQ,EAAE,8BAA8B;EACxC,SAAS;EACT,uBAAuB;EACvB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB","sourcesContent":[".paper-canvas {\n  top: 1px; /* leave room for the border */\n  left: 1px;\n  width: calc(100% - 2px);\n  height: calc(100% - 2px);\n  margin: auto;\n  position: absolute;\n  background-color: #d9e3f2;\n}\n[data-paint-theme='dark'] .paper-canvas {\n  background-color: #222;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper-canvas": `paper-canvas_paper-canvas_IICvh`,
	"paperCanvas": `paper-canvas_paper-canvas_IICvh`
};
export default ___CSS_LOADER_EXPORT___;
